import * as React from "react";
import { ShieldCheck, Leaf, Microscope, CircleCheck, CircleX } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const certifications = [{
  title: "SSL Secure Encryption",
  description: "Every transaction and message is protected by military-grade 256-bit SSL encryption.",
  icon: ShieldCheck
}, {
  title: "Privacy Shield Certified",
  description: "We adhere to strict data sovereignty protocols. Your personal info is never for sale.",
  icon: Leaf
}, {
  title: "Toronto Tech Verified",
  description: "Independently audited for security standards within the GTA technology ecosystem.",
  icon: Microscope
}];
const comparisonData = [{
  feature: "Data Encryption",
  glowSilk: "End-to-end AES-256 bit encryption",
  generic: "Unsecured or basic plaintext storage"
}, {
  feature: "Payment Processing",
  glowSilk: "PCI-DSS Level 1 compliant gateways",
  generic: "Manual transfers or unverified 3rd party links"
}, {
  feature: "User Verification",
  glowSilk: "Strict .edu or professional email checks",
  generic: "Anonymous profiles with no accountability"
}, {
  feature: "Dispute Resolution",
  glowSilk: "24/7 Local Toronto support team",
  generic: "Automated bots or non-existent support"
}];
export default function DermatologistApproved() {
  return <section data-section-id="111768" id="safety-first" className="bg-background dark relative overflow-hidden py-16 md:py-24 border-y border-dashed border-primary/40">
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_70%)] opacity-10" />

      <div className="container mx-auto max-w-5xl px-4">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="text-foreground mb-4 font-sans text-3xl font-black tracking-tighter uppercase md:text-5xl">
            Secure by Design. Toronto Trusted.
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg font-medium">
            HalfOrder is built with the same security standards as global fintech apps, ensuring your shared meals are as safe as they are affordable for students and professionals.
          </p>
        </div>

        {}
        <div className="mb-16 grid grid-cols-1 gap-4 md:grid-cols-3">
          {certifications.map((cert, i) => <Alert key={i} data-index={i} className="bg-card border-border/50 shadow-sm transition-all hover:shadow-primary/20 hover:shadow-lg rounded-sm">
              <cert.icon className="text-primary size-5" />
              <AlertTitle className="text-foreground font-bold tracking-tight">
                {cert.title}
              </AlertTitle>
              <AlertDescription className="text-muted-foreground mt-1 text-sm">
                {cert.description}
              </AlertDescription>
            </Alert>)}
        </div>

        {}
        <div className="bg-card border-border shadow-2xl mx-auto max-w-4xl overflow-hidden rounded-sm border">
          <div className="bg-muted/30 border-border border-b px-6 py-6 text-center md:px-8">
            <h3 className="text-foreground font-sans text-xl font-black tracking-tighter uppercase md:text-2xl">
              The HalfOrder Security Standard
            </h3>
            <p className="text-muted-foreground mt-2 text-sm font-mono">
              COMPARING OUR PROTOCOLS AGAINST UNVERIFIED ALTERNATIVES
            </p>
          </div>
          <div className="p-0">
            <Table>
              <TableHeader>
                <TableRow className="hover:bg-transparent border-border">
                  <TableHead className="w-[25%] py-4 pl-6 md:w-[30%] font-bold uppercase text-xs tracking-widest">
                    Feature
                  </TableHead>
                  <TableHead className="bg-primary/10 text-primary w-[35%] py-4 font-black uppercase text-xs tracking-widest md:w-[35%]">
                    HalfOrder
                  </TableHead>
                  <TableHead className="text-muted-foreground w-[40%] py-4 pr-6 font-bold uppercase text-xs tracking-widest md:w-[35%]">
                    Generic Apps
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="group border-border">
                    <TableCell className="text-foreground py-4 pl-6 font-bold text-sm">
                      {row.feature}
                    </TableCell>
                    <TableCell className="bg-primary/5 py-4">
                      <div className="flex items-start gap-2 md:items-center">
                        <CircleCheck className="text-primary mt-0.5 size-4 shrink-0 md:mt-0" />
                        <span className="text-foreground text-sm font-medium md:text-base">
                          {row.glowSilk}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell className="py-4 pr-6">
                      <div className="text-muted-foreground flex items-start gap-2 md:items-center">
                        <CircleX className="mt-0.5 size-4 shrink-0 md:mt-0 opacity-50" />
                        <span className="text-sm md:text-base">
                          {row.generic}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </section>;
}